<template>
	<div class="pipeline-number-stat" :type="type">
		<div class="value">
			{{ value }}
		</div>
		<div class="separator">/</div>
		<div class="label">
			{{ label }}
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "PipelineNumberStat",
	props: {
		value: {
			type: String,
			default: ""
		},
		label: {
			type: String,
			default: ""
		},
		/**
		 * 'success' | 'error' | 'inProgress' | 'warning' | 'standby' | 'paused' | 'disabled'
		 */
		type: {
			type: String,
			default: "inProgress",
			validator(value) {
				return [
					"success",
					"error",
					"inProgress",
					"warning",
					"standby",
					"paused",
					"disabled"
				].includes(value);
			}
		}
	}
});
</script>
<style lang="scss">
$label-color: var(--dashboard-font-light);
$value-font-size: 72px;
$label-font-size: 48px;
$types: (
	"success": var(--dashboard-success),
	"error": var(--dashboard-danger),
	"warning": var(--dashboard-warning),
	"inProgress": var(--dashboard-primary),
	"standby": var(--dashboard-font-light),
	"paused": var(--dashboard-font-light),
	"disabled": var(--dashboard-font-light)
);

.pipeline-number-stat {
	display: flex;
	font-family: var(--number-font);
	align-items: flex-end;
	// padding-bottom: 8px;

	> .value {
		font-size: $value-font-size;
		line-height: $value-font-size - 18;
		font-weight: 400;
	}

	> .separator {
		margin-left: 8px;
		margin-right: 8px;
	}

	> .label,
	> .separator {
		font-size: $label-font-size;
		color: $label-color;
		text-transform: uppercase;
		line-height: 36px;
		font-weight: 400;
	}

	@each $type, $color in $types {
		&[type="#{$type}"] {
			> .value {
				color: $color;
			}
		}
	}
}
</style>
